import { render, staticRenderFns } from "./PersontypeSimple.vue?vue&type=template&id=18a0f286&"
import script from "./PersontypeSimple.vue?vue&type=script&lang=js&"
export * from "./PersontypeSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports